var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadAudioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.552 5.44422L4.37407 10.5346C4.10281 10.8138 3.95239 11.1884 3.95532 11.5775C3.95825 11.9666 4.1143 12.339 4.38974 12.6141C4.66518 12.8891 5.03789 13.0449 5.42733 13.0477C5.81676 13.0504 6.19165 12.9 6.47096 12.6288L13.1314 6.05803C13.6876 5.50238 14 4.74874 14 3.96293C14 3.17711 13.6876 2.42348 13.1314 1.86782C12.5753 1.31216 11.821 1 11.0346 1C10.2481 1 9.49379 1.31216 8.93766 1.86782L2.27718 8.43951C1.45431 9.27519 0.995259 10.4019 1.00004 11.5742C1.00481 12.7465 1.47303 13.8695 2.30269 14.6984C3.13235 15.5274 4.25625 15.9952 5.42956 16C6.60287 16.0047 7.73053 15.5461 8.56693 14.7239L13.629 9.88811",
    stroke: "#1A1A1A",
    strokeOpacity: 0.7,
    strokeWidth: 1.8,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAudioIcon);
export default __webpack_public_path__ + "static/media/upload-audio-icon.8bef4b2f.svg";
export { ForwardRef as ReactComponent };